import { useQueryControl } from '@bonusly/url';

import { DateTimeFrame } from '../types/date-time-frame';

export const allowedValues: DateTimeFrame[] = ['30d', '3m', '6m', '1y', 'all'];

export const useDateQuery = () => {
	return useQueryControl<DateTimeFrame>('date', {
		allowedValues,
		defaultValue: '30d',
	});
};
